
import { computed, defineComponent, PropType, reactive, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// types
import { SenderT } from '@/core/types/senders.types'

// realisations
import { senders } from '@/core/realisations/senders.realisation'

// composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        'the-button': TheButton,
        cheap: Cheap,
    },
    props: {
        item: {
            type: Object as PropType<SenderT>,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'update', 'deleted'],
    setup(props, { emit }) {
        const state = reactive({
            is_deleting: false,
        })

        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const notifications = useNotifications()

        const emitDelete = async () => {
            const answer = confirm(
                `Вы действительно хотите удалить отправителя ${props.item.title}?`
            )

            if (!answer) return

            try {
                state.is_deleting = true

                await senders.deleteSender(props.item.id)
                notifications.notify({
                    title: `Отправитель ${props.item.title} удалён`,
                    type: 'success',
                })

                emit('deleted')
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: `Ошибка при удалении отправителя ${props.item.title}`,
                })
            } finally {
                state.is_deleting = false
            }
        }

        const isSenderHaveCoordinates = computed(() => {
            if (Boolean(props.item.latitude) && Boolean(props.item.longitude)) {
                return true
            }

            return false
        })

        const emitSubmit = () => {
            if (!isSenderHaveCoordinates.value) {
                notifications.notify({
                    title: 'Не указан адрес',
                    description: 'Пожалуйста, укажите адрес на карте',
                    type: 'danger',
                })

                emit('update', toRaw(props.item))
                return
            }

            emit('submit', toRaw(props.item))
        }

        return { state, emitSubmit, emitUpdate, emitDelete, isSenderHaveCoordinates }
    },
})
